import React, { useState, useEffect } from 'react';

function MyLocation(props) {
  const {setLocation} = props 
  const [position, setPosition] = useState({ latitude: null, longitude: null });

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        setPosition({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      console.log("Geolocation is not available in your browser.");
    }
  }, []);

  useEffect(() => {
    // Fetch location details based on latitude and longitude
    if (position && position.longitude !== null) {
      fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.latitude}&longitude=${position.longitude}&localityLanguage=en`)
        .then(response => response.json())
        .then(data => {
          setLocation(data.locality + ', '+ data.city+', ' + data.principalSubdivision + ', ' + data.countryName);
        })
        .catch(error => {
          console.error('Error fetching location details:', error);
        });
    }
  }, [position]);

  return (  
    <></>
  );
}

export default MyLocation;